import { render, staticRenderFns } from "./FormThanks.vue?vue&type=template&id=e099aaa8&scoped=true&"
import script from "./FormThanks.vue?vue&type=script&lang=js&"
export * from "./FormThanks.vue?vue&type=script&lang=js&"
import style0 from "./FormThanks.vue?vue&type=style&index=0&id=e099aaa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e099aaa8",
  null
  
)

export default component.exports